import { Material } from "../Material/Material.type";
import { MaterialInventory } from "../MaterialInventory/MaterialInventory.type";
import { MaterialRequisition } from "../MaterialRequisition/MaterialRequisition.type";
import { Project, Store } from "../Project/Project.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type GoodOut = {
  id: number;
  from_id: number;
  key?: any;
  date: string;
  to_id: number;
  from_project_location: Project;
  to_project_location: Project;
  to_store_id: number;
  from_store_id: number;
  to_project_id: number;
  from_store_location: Store;
  to_store_location: Store;
  // Backend alias fields (optional)
  dispatching_warehouse_id?: number;
  receiving_warehouse_id?: number;
  good_out_dispatching_warehouse?: Store;
  good_out_receiving_warehouse?: Store;
  good_out_from_project?: Store;
  good_out_to_project?: Store;
  mode: string;
  in_date: string;
  out_date: string;
  user_id: number;
  checked_by: string;
  from_project_id: number;
  good_out_items: GoodOutItem[];
  vehicle_used: VehicleUsed[];
  go_prepared_by?: User;
  go_checked_by?:User;
  is_done: boolean;
  good_out_statuses: GoodOutStatus[];
};

export type GoodOutStatus = {
  good_out_id: number;
  type: "View" | "Check" | "Approve";
  status: number;
  assigned_by: number;
  user_id: number;
  id: number;
};

export type GoodOutItem = {
  id: number;
  material_requisition_id: number;
  material_id: number;
  material: Material;
  material_requisition: MaterialRequisition;
  material_inventory: MaterialInventory;
  equipment_inventory: any;
  quantity: number;
  identification_number: number;
  unit: string;
};
export type VehicleUsed = {
  equipment_inventory_id: number;
  equipment_inventory: any;
  staff_id: number;
};

export type GoodOutStateTypes = {
  fetchAll: ApiCallState<GoodOut[]>;
  fetchOne: ApiCallState<GoodOut | null>;
};

export const GoodOutActionTypes = {
  FETCH_ALL_GOOD_OUT: "FETCH_ALL_GOOD_OUT",
  FETCH_ALL_GOOD_OUT_RESET: "FETCH_ALL_GOOD_OUT_RESET",
  FETCH_ALL_GOOD_OUT_FAILURE: "FETCH_ALL_GOOD_OUT_FAILURE",
  FETCH_ALL_GOOD_OUT_SUCCESS: "FETCH_ALL_GOOD_OUT_SUCCESS",

  FETCH_ONE_GOOD_OUT: "FETCH_ONE_GOOD_OUT",
  FETCH_ONE_GOOD_OUT_RESET: "FETCH_ONE_GOOD_OUT_RESET",
  FETCH_ONE_GOOD_OUT_FAILURE: "FETCH_ONE_GOOD_OUT_FAILURE",
  FETCH_ONE_GOOD_OUT_SUCCESS: "FETCH_ONE_GOOD_OUT_SUCCESS",

};
